import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { User } from 'src/models/user';
import { HelperService } from 'src/services/helperService';
import { APIReportServiceIncadea } from 'src/services/api-services/api-reports-incadea-services';
import { Observable, catchError, map, reduce, tap, throwError } from 'rxjs';
import moment from 'moment';

import { ServiceAdvisor } from 'src/services/api-services/api-interfaces/ServiceAdvisor.interface';
import { dataReports, labelFilterIncadea, reportIncadea, reports } from 'src/services/api-services/api-interfaces/api-interface-incadea-reports';
import { Resource } from '../../../services/api-services/api-interfaces/IBAppointmentGET.interface';


@Component({
    selector: 'app-i-reports',
    templateUrl: './i-reports.component.html',
    styleUrls: ['./i-reports.component.sass'],
    standalone: false
})

export class IReportsComponent implements OnInit {

  reportName: string='';
  isVisibleExport: boolean=false;
  isVisibleTable: boolean=false;
  isLoading: boolean= false;
  disableCompany: boolean= false;
  disableDepartment: boolean= false;
  disableLocation: boolean = false;
  dataSearched: boolean = false;
  isDisabled: boolean = true;
  loading: boolean = true;
  isDisabledReport: boolean = true;
  isCompanyId:number=0;
  roleId: number=this.helperService.user.role.roleId
  retailId: number = this.helperService.user.retailId
  userId:number=this.helperService.user.userid
  sumtotalColumn: any[]=[]
  rowTotals: any[]=[]
  total: any[] = [];
  dataCompanies$: Observable<dataReports[]> =  new Observable<dataReports[]>();
  dataResource!: ServiceAdvisor[]
  dataService!: dataReports[];
  dataBrand!:any[];
  dataShow=[]
  textHeaders:string[]=[]
  diccionary:reportIncadea  ={} as reportIncadea ;
  // LocationId:string = ""
  CompanyId: string = ""
  locations!:any[]
  Deparments$: Observable<any[]> =  new Observable<any[]>();
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  companyId?: string = this.helperService.user.incadeaCompanyId
  countryId: number = this.helperService.user.countryId
  startDate: string = "";
  endDate: string = "";
  LocationId:string = ""
  companyName:string=""
  locationData:any[]=[]
  reportId: number = 0;
  companiesName:any[]=[]
  departmentData:any[]=[]
  brandData:any[]=[]
  serviceData:any[]=[]
  resourceData:any[]=[]
  locationDataProfile:any[]=[]
  makeCode: string = "";
  ResourceId: string=""
  serviceId: string = ""
  disableResource: boolean = false;
  disableServices: boolean = false;
  disableBrands: boolean = false;
  user: User=this.helperService.user
  allowedRoles = [3, 4, 5];//preguntar a camilo
  DeparmentCode: string= ""
  reportsList: Observable<reports[]> =  new Observable<reports[]>();

  constructor(
    public helperService: HelperService,
 
    public ReportServiceIncadea :APIReportServiceIncadea,
    @Inject(LOCALE_ID)
    public localeId: string,
  ) { }


  ngOnInit(): void {
    this.helperService.TitlePage = 'Reports'
    this.helperService.icon = "pie_chart_outline"
    //brings the list of reports according to the roleId
    this.reportsList= this.ReportServiceIncadea?.getReportsFilterDropDownIncadeaReport(this.roleId)
    .pipe(
      tap(()=>{
        if(this.isDisabledReport){
          this.loading= false
          this.isDisabledReport= false
        }
      }), catchError((error: any) => {
                     // Handle validation error here
                     if(error.status === 401){
                      this.helperService.logoutToken()
                    }
                   console.error('Validation Error:', error);
                   // Rethrow the error to propagate it downstream
                   return throwError(error);
                   })
    )
    //dynamically wraps the HTML depending on the roleId
    const dropdowSize = this.allowedRoles.includes(this.roleId) ? '4%' : '10%';
    document.documentElement.style.setProperty('--dropdow-Size', dropdowSize);
  }

  dateFilterEnd = (date): boolean  => {

    if(date >= this.startDate){
      return true;
    }
    else{
      return false;
    }
  }

  ChangeDateEnd() {
    
    if (this.startDate > this.endDate) {
      this.endDate = this.startDate;
    }
  }

    getNameCompany(){
      this.companyId=this.roleId===4 ? this.companyId:undefined
      if(this.reportId!==15){
      this.ReportServiceIncadea?.getReportsFilterDropDownIncadea(this.roleId, this.countryId, this.companyId)
        .subscribe({next:(response)=>{
          this.companyName=response[0][0].CompanyName
          this.companiesName=response[0]
          this.locationData=response[1]
          this.isDisabled=false   
        },error: (error) => {
         
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error("cant retrieve User exception", error);
        }
      }) 
      }else{
        this.ReportServiceIncadea?.getReportsFilterDropDownIncadea(this.roleId, this.countryId, this.companyId)
        .subscribe({next:(response)=>{
          this.companyName=response[0][0].CompanyName
        },error: (error) => {
         
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error("cant retrieve User exception", error);
        }
      }
        ) 
       this.disabledDropdowns("reportId15")
       this.isDisabled=false
      }
    }

    getNameLocation(){
      this.ReportServiceIncadea?.getReportsFilterDropDownIncadea(this.roleId, this.countryId, this.companyId)
        .subscribe({next:(response)=>{
          this.locationData=response[this.roleId===4 ? 1:0]
          this.isDisabled=false     
        },error: (error) => {
         
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error("cant retrieve User exception", error);
        }
      }) 
    }

    getNameDeparment(){
      this.ReportServiceIncadea?.getReportsFilterDropDownIncadea(this.roleId, this.countryId, this.companyId, this.LocationId)
        .subscribe({next:(response)=>{
          this.departmentData=response[0]
        },error: (error) => {
         
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error("cant retrieve User exception", error);
        }
      })

      
    }

    getNameBrandServiceResource(){
      this.ReportServiceIncadea?.getReportsFilterDropDownIncadea(this.roleId, this.countryId, this.companyId, this.LocationId, this.DeparmentCode)
        .subscribe({next:(response)=>{
          this.brandData=response[0]
          this.serviceData=response[1]
          this.resourceData=response[2]
        },error: (error) => {
         
          if(error.status === 401){
            this.helperService.logoutToken()
          }
          console.error("cant retrieve User exception", error);
        }
      })
      
    }


    disabledDropdowns(name:string){
      switch(name){
        case "reportId15":
          this.disableCompany=true
          this.disableLocation=true
          this.disableBrands=true
          this.disableDepartment=true
          this.disableServices =true 
          this.disableResource=true
        break;
        case "brand":
          this.disableServices =true 
          this.disableResource=true
          break;
        case "service":
          this.disableBrands=true
          this.disableResource=true
          break;  
        case "resource":
          this.disableBrands=true
          this.disableServices =true
          break; 
        
      }
    }

    //send the values to the backend and search for the respective report.
    //is Export can be 0 or 1, 0 meaning getting the data on screen. 1 is to get the data as pdf
    searchReport(isExport:number){
      this.diccionary={
        pcountryId:(this.countryId ? this.countryId.toString() : "0"),
        pcompanyId:(this.companyId ? this.companyId.toString() : null),
        plocationId:(this.LocationId ? this.LocationId.toString() : null),
        pdepartmentCode:(this.DeparmentCode ? this.DeparmentCode.toString() : null),
        pmakeCode:(this.makeCode ?  this.makeCode.toString() : null),
        pserviceId:(this.serviceId ? this.serviceId.toString() : null),
        presourceId:(this.ResourceId? this.ResourceId.toString() : null),
        pInitialDate:moment(this.startDate).format('YYYY-MM-DD'),
        pFinalDate:moment(this.endDate).format('YYYY-MM-DD'),
      }
      this.isLoading=true
      this.getReport(isExport)

    }


    isSearchDisable(){
      return false
    }
    clearFilter(){
      this.reportId = 0
      this.companyId =  this.roleId === 3 ? "" : this.companyId
      this.LocationId=""
      this.DeparmentCode=""
      this.makeCode=""
      this.serviceId=""
      this.ResourceId=""
      this.startDate= ""
      this.endDate= ""
      this.disableBrands=false
      this.disableServices =false
      this.disableResource=false
      this.disableDepartment=false
      this.disableCompany=false
      this.disableLocation=false
      this.companyName=""

    }

    getReport(isExport:number){
          this.ReportServiceIncadea?.post(this.roleId,this.reportId,isExport,1,this.diccionary)
          .subscribe((blob: any) => {
            this.dataSearched = true;
            if (isExport === 1) {
              this.isVisibleTable = true;
              const downloadUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = downloadUrl;
              a.download = `${this.reportName}_${moment(this.startDate).format('YYYY-MM-DD')}_${moment(this.endDate).format('YYYY-MM-DD')}.xlsx`;
              document.body.appendChild(a);
              a.click();
              setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
              }, 100);
            } else {
                if (!blob.message) {
                  // the sum of the values obtained is being made
                  this.dataShow = blob;
                  if (this.dataShow.length <= 0) {
                    this.isLoading = false;
                    return;
                  }
      
                  this.rowTotals = this.dataShow.map((item: any) => {
                    const rowValues = Object.values(item);
                    return rowValues.reduce((numero: number, numero2: unknown) => {
                      if (typeof numero2 === 'number') {
                        return numero + numero2;
                      }
                      return numero; //Ignore non-number values
                    }, 0);
                  });
                  // console.log(this.rowTotals);
      
                  this.sumtotalColumn = this.rowTotals.reduce(
                    (prev: number, next: number) => prev + next,
                    0
                  );
      
                  this.textHeaders = Object.keys(this.dataShow[0]);
                  this.isVisibleExport = true;
                  this.isLoading = false;
                  this.total = [];
                  this.textHeaders.forEach((element, index) => {
                    const SumaTotal = this.dataShow.map((item: any) => item[element]);
                    // console.log(SumaTotal);
      
                    this.total[index] = SumaTotal.reduce(
                      (numero: number, numero2: number) => numero + numero2,
                      0
                    );
                    if (String(this.total[index])) {
                      this.total[index] = 'Total';
                    }
                    // console.log('headers', this.textHeaders);
                  });
                }
              }
          });
      
        }
      

}

